require('./overrides.scss')
require('./preset.scss')

const preset = {
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: '369906A7',
      customProperties: true,
      variations: true,
      minifyTheme: undefined,
      themeCache: undefined
    },
    themes: {
      light: {
        primary: '#7e57c2',
        secondary: '#3f51b5',
        accent: '#8bc34a',
        error: '#f44336',
        info: '#2196f3',
        success: '#4caf50',
        warning: '#ffc107'
      }
    }
  },
  icons: {
    iconfont: 'fa',
    values: {
      // vuetify
      ban: 'fal fa-ban',
      cancel: 'fal fa-times',
      checkboxIndeterminate: 'fal fa-minus-square',
      checkboxOff: 'far fa-square', // note 'far'
      checkboxOn: 'fal fa-check-square',
      clear: 'fas fa-times-circle', // delete (e.g. v-chip close)
      close: 'fal fa-times',
      collapse: 'fal fa-chevron-up',
      complete: 'fal fa-check',
      delete: 'fas fa-times-circle', // delete (e.g. v-chip close)
      delimiter: 'fal fa', // for carousel
      dropdown: 'fas fa-caret-down',
      edit: 'fal fa-pencil',
      error: 'fal fa-exclamation-triangle',
      expand: 'fal fa-chevron-down',
      info: 'fal fa-info-circle',
      menu: 'fal fa-bars',
      minus: 'fas fa-minus-circle',
      next: 'fal fa-chevron-right',
      plus: 'fas fa-plus-circle',
      prev: 'fal fa-chevron-left',
      radioOff: 'fal fa-circle',
      radioOn: 'fal fa-dot-circle',
      ratingEmpty: 'far fa-star',
      ratingFull: 'fas fa-star',
      ratingHalf: 'fas fa-star-half',
      sort: 'fal fa-arrow-up',
      subgroup: 'fas fa-caret-down',
      success: 'fal fa-check-circle',
      warning: 'fal fa-exclamation-circle',
      // app
      access: 'fal fa-key',
      attachment: 'fal fa-paperclip',
      add: 'fal fa-plus',
      addCircle: 'fal fa-plus-circle',
      addCircleInverted: 'fas fa-plus-circle',
      addUser: 'fal fa-user-plus',
      back: 'fal fa-backward',
      birthday: 'fal fa-birthday-cake',
      boards: 'fal fa-clipboard',
      calendar: 'fal fa-calendar',
      cancelCircle: 'fal fa-times-circle',
      cancelCircleInverted: 'fas fa-times-circle',
      check: 'fal fa-check',
      clock: 'fal fa-clock',
      clearCircle: 'fal fa-times-circle',
      columnsView: 'fal fa-columns',
      comment: 'fal fa-comment-alt',
      copy: 'fal fa-sticky-note',
      deleteCircle: 'fal fa-times-circle',
      delimiterCircle: 'fal fa-circle',
      demo: 'fal fa-suitcase',
      doc: 'fal fa-file-word',
      docx: 'fal fa-file-word',
      down: 'fal fa-arrow-down',
      download: 'fal fa-arrow-to-bottom',
      egress: 'fal fa-arrow-from-left',
      email: 'fal fa-at',
      entities: 'fal fa-boxes',
      file: 'fal fa-file',
      flows: 'fal fa-code-branch',
      forward: 'fal fa-forward',
      groups: 'fal fa-user-friends',
      help: 'fal fa-question',
      helpCircle: 'fal fa-question-circle',
      home: 'fal fa-home',
      ingress: 'fal fa-arrow-to-right',
      inviteUser: 'fal fa-envelope-open-text',
      jpeg: 'fal fa-file-image',
      jpg: 'fal fa-file-image',
      language: 'fal fa-language',
      launcher: 'fal fa-rocket',
      mobile: 'fal fa-mobile',
      options: 'fal fa-cog',
      order: 'fal fa-sort',
      organization: 'fal fa-building',
      password: 'fal fa-lock',
      pdf: 'fal fa-file-pdf',
      phone: 'fal fa-phone',
      png: 'fal fa-file-image',
      question: 'fal fa-question',
      reminder: 'fal fa-bell',
      reset: 'fal fa-sync-alt',
      save: 'fal fa-save',
      search: 'fal fa-search',
      settings: 'fal fa-sliders-h',
      sortDown: 'fal fa-sort-amount-down',
      sortUp: 'fal fa-sort-amount-up',
      sortUpDown: 'fal fa-arrows-v',
      stateFailure: 'fas fa-times-circle',
      stateMissing: 'fas fa-info-circle',
      statePending: 'fas fa-exclamation-circle',
      stateSuccess: 'fas fa-check-circle',
      system: 'fal fa-power-off',
      tableView: 'fal fa-th-list',
      tag: 'fal fa-tag',
      text: 'fal fa-align-left',
      ticket: 'fal fa-ticket-alt',
      todo: 'fal fa-check-square',
      token: 'fal fa-fingerprint',
      transition: 'fal fa-chart-network',
      trash: 'fal fa-trash',
      up: 'fal fa-arrow-up',
      upload: 'fal fa-upload',
      user: 'fal fa-user',
      users: 'fal fa-users',
      view: 'fal fa-arrow-right',
      viewBack: 'fal fa-arrow-left',
      viewBackCircle: 'fal fa-arrow-circle-left',
      viewCircle: 'fal fa-arrow-circle-right',
      xls: 'fal fa-file-excel',
      xlsx: 'fal fa-file-excel'
    }
  }
}

module.exports = { preset }
